<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert v-model="showAlert" variant="warning" dismissible>
    {{ alertMsg }}
  </b-alert>

  <b-modal v-model="showModal" ref="delete" id="delete" title="Conferma cancellazioe" @ok="handleDelete" @cancel="handleCancel">
    <h3>Sei sicuro di voler cancellare la riga?</h3>
  </b-modal>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Unità di Misura"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <span class='label'>
                Unità di misura
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-input v-model="form_data.measure_unit" class=""></b-form-input>
            </b-col>
          </b-row>            
          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>
          <b-row>
            <b-col cols="2">
              <b-button variant="warning" @click="cancelUM">Annulla</b-button>
            </b-col>          
            <b-col cols="7">
              &nbsp;
            </b-col>          
            <b-col cols="2">
              <b-button v-if="!current_id" variant="primary" @click="insertUM">Inserisci</b-button>
              <b-button v-if="current_id" variant="success" @click="updateUM">Aggiorna</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        title="Lista Unità di Misura"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">
              <table class="" :key="paginatedUM.length">
                <thead>
                  <tr>
                    <th style="width: 0%;"></th>
                    <th style="width: 95%;">Unità di misura</th>
                    <th style="width: 5%;"></th>
                  </tr>
                </thead>
                <tbody>                  
                  <tr v-for="base in paginatedUM" :key="base.id" class="row-selection">
                    <td @click="editRow(base)" style="visibility: hidden;">{{ base.id }}</td>
                    <td @click="editRow(base)">{{ base.measure_unit }}</td>
                    <td>
                      <i
                        class="fas fa-trash"
                        @click="deleteRecord(base.id)"
                        style="pointer: cursor !important;"
                      ></i>
                    </td>
                  </tr>                
                </tbody>
              </table>
            </b-col>
            <b-col cols="10">
              <b-pagination
                v-model="currentPage"
                :total-rows="total_rows"
                :per-page="perPage"
                aria-controls="my-table"
                @change="onPageChange"
                class="my-3"
              >               
              </b-pagination>
            </b-col>
            <b-col cols="2" style="margin-top: 1.5rem;">
                <b-form-select v-model="perPage" :options="[5, 10, 15, 20]" class="mb-3" style="width: 6rem;" @change="onPerPageChange"></b-form-select>
            </b-col>            
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>

</div>